import { Form, Row, Col, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, Breadcrumb, BreadcrumbItem, Container } from 'reactstrap';
import React, { useState, useRef, Component } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import VaporesSemanalesProveedorTable from "../VaporesSemanalesProveedor/VaporesSemanalesProveedorTable"
import { VaporesSemanalesProveedorView } from "./VaporesSemanalesProveedorView"
import { VaporesSemanalesProveedorDelete } from "./VaporesSemanalesProveedorDelete"
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import CleaningServicesOutlinedIcon from '@mui/icons-material/CleaningServicesOutlined';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';

import { Breadcrumbs } from '../General/Breadcrumbs';
import authService from '../api-authorization/AuthorizeService'

export class VaporesSemanalesProveedor_Index extends Component {
    static displayName = VaporesSemanalesProveedor_Index.name;
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            loading: true,
            modalState: false,
            modalHeader: "Cargando",
            modalBody: () => { return (<div>Cargando</div>); },
            modalOperation: 'add',
            modalIsValid: false,
            searchModel: { viaje: "", naviera_Id: 0, vaporSemanal_Id: 0 },
            semana: {},
            navieras: [],
            barcos: []
        };
        this.load_semana = this.load_semana.bind(this);
        this.load_navieras = this.load_navieras.bind(this);
        this.load_barcos = this.load_barcos.bind(this);
        this.populateData = this.populateData.bind(this);
        this.modalBodyState = {};
        this.modalToggle = this.modalToggle.bind(this);
        this.add_onclick = this.add_onclick.bind(this);
        this.add_modal_guardar_onclick = this.add_modal_guardar_onclick.bind(this);
        this.edit_onclick = this.edit_onclick.bind(this);
        this.edit_modal_guardar_onclick = this.edit_modal_guardar_onclick.bind(this);
        this.delete_onclick = this.delete_onclick.bind(this);
        this.delete_modal_guardar_onclick = this.delete_modal_guardar_onclick.bind(this);
        this.setModalBodyState = this.setModalBodyState.bind(this);
        this.modalSubmit = this.modalSubmit.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.clean_onclick = this.clean_onclick.bind(this);
    }

    componentDidMount() {
        this.populateData();
    }

    modalToggle() {
        this.setState({
            modalState: !this.state.modalState
        });
    }

    renderTable() {
        return (
            <div  >
                <Row>
                    <Form >
                        <Row>
                            <Col md="3">
                                <FormGroup>
                                    <Label for="naviera_Id">
                                        <FormattedMessage id='Naviera' />
                                    </Label>
                                    <Input
                                        id="naviera_Id"
                                        name="naviera_Id"
                                        type="select"
                                        onChange={this.handleSearchChange}
                                    >
                                        <option key="0" value="0"></option>
                                        {this.state.navieras.map(naviera => naviera.naviera_Id == this.state.searchModel.naviera_Id ? (
                                            <option key={naviera.naviera_Id} value={naviera.naviera_Id} selected>
                                                {naviera.nombre}
                                            </option>
                                        ) : (<option key={naviera.naviera_Id} value={naviera.naviera_Id}>{naviera.nombre}</option>))}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md="3">
                                <FormGroup>
                                    <Label for="vaporSemanal_Id">
                                        <FormattedMessage id='Vapor' />
                                    </Label>
                                    <Input
                                        id="vaporSemanal_Id"
                                        name="vaporSemanal_Id"
                                        type="select"
                                        onChange={this.handleSearchChange}
                                    >
                                        <option key="0" value="0"></option>
                                        {this.state.barcos.map(barco => barco.vaporSemanal_Id == this.state.searchModel.vaporSemanal_Id ? (
                                            <option key={ barco.vaporSemanal_Id } value={barco.vaporSemanal_Id} selected>
                                                {barco.barcoViaje}
                                            </option>
                                        ) : (<option key={barco.vaporSemanal_Id} value={barco.vaporSemanal_Id}>{barco.barcoViaje}</option>))}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col className="col-auto">
                                <FormGroup>
                                    <IconButton size='small' className='SearchButton IndexButton' onClick={this.populateData}>
                                        <SearchIcon />
                                    </IconButton>
                                </FormGroup>
                            </Col>
                            <Col className="col-auto">
                                <FormGroup>
                                    <Button className="CleanButton IndexButton" onClick={this.clean_onclick}>
                                        <CachedOutlinedIcon fontSize='large' /> <FormattedMessage id='Limpiar' />
                                    </Button>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                </Row>
                <Row>
                    <VaporesSemanalesProveedorTable data={this.state.data} add_onclick={this.add_onclick} edit_onclick={this.edit_onclick} delete_onclick={this.delete_onclick} />
                </Row>
                <Modal size="lg" isOpen={this.state.modalState} toggle={this.modalToggle}>
                    <ModalHeader toggle={this.modalToggle}>
                        {this.state.modalHeader}
                    </ModalHeader>
                    <ModalBody>
                        {this.state.modalBody}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.modalSubmit} disabled={!this.state.modalIsValid}>
                            {this.state.modalOperation == 'delete' ? <FormattedMessage id='Eliminar' /> : <FormattedMessage id='Guardar' />}
                        </Button>{' '}
                        <Button color="secondary" onClick={this.modalToggle}>
                            Cancelar
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

    render() {
        let breadcrumbsData = this.state.loading
            ? <p></p>
            : <Breadcrumbs data={[
                { link: "/Semanas", message: "Semanas", active: true },
                { link: "/Semanas/" + this.state.semana.semana_Id + "/VaporesSemanalesProveedor", message: "Vapores Semanales", active: false },
            ]} />;
        let contents = this.state.loading
            ? <p><em>Cargando...</em></p>
            : this.renderTable();

        return (
            <div style={{ width: '100%' }}>
                <h2><FormattedMessage id='Vapores Semanales' /></h2>
                {breadcrumbsData}
                
                <div className="viewContainerHeader ">
                    <div className="d-flex justify-content-start">
                        <div className="px-4 py-2"><FormattedMessage id='Semana' />: {this.state.semana.nombre}</div>
                        {/*<div className="px-4 py-2"><FormattedMessage id='Barco' />: {this.state.contenedorSemanal.barco}</div>*/}
                    </div>
                    <div className="d-flex justify-content-start">
                        {/*<div className="px-4 py-2"><FormattedMessage id='Contenedor' />: {this.state.contenedorSemanal.contenedor}</div>*/}
                        {/*<div className="px-4 py-2"><FormattedMessage id='EtiquetaEspecial' />: {this.state.contenedorSemanal.etiquetaEspecial}</div>*/}
                    </div>
                </div>
                <div className="viewContainer-lg">
                    {contents}
                </div>

            </div>
        );
    }

    async populateData() {
        this.setState({ loading: true, semana: await this.load_semana(), navieras: await this.load_navieras() }, async () => {
            const token = await authService.getAccessToken();
            var queryString = '?semana_Id=' + this.state.semana.semana_Id + '&';
            Object.keys(this.state.searchModel).forEach(key => {
                queryString += key + "=" + this.state.searchModel[key] + "&";
            });
            queryString = queryString.slice(0, -1);
            const response = await fetch('api/vaporesSemanalesProveedor' + queryString, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            });
            const responceData = await response.json();
            this.setState({ data: responceData, loading: false });

        });
    }

    async handleSearchChange(event) {
        event.preventDefault();
        var searchModel = this.state.searchModel;
        searchModel[event.target.name] = event.target.value;
        this.setState({ searchModel: searchModel }, async () => {
            if (event.target.name == "naviera_Id") {
                this.setState({
                    barcos: await this.load_barcos()
                });
            }
        });

    }
    async modalSubmit(id) {
        if (this.state.modalOperation == 'add') {
            this.add_modal_guardar_onclick();
        }
        else if (this.state.modalOperation == 'edit') {
            this.edit_modal_guardar_onclick(id);
        }
        else if (this.state.modalOperation == 'delete') {
            this.delete_modal_guardar_onclick(id);
        }
    }
    async add_onclick() {
        this.setState({
            modalHeader: this.add_modal_header(),
            modalBody: this.add_modal_body(),
            modalState: true,
            modalOperation: 'add',
        });
    }
    add_modal_header() {
        return (<div><FormattedMessage id='Nuevo' /></div>);
    }
    add_modal_body() {
        return (<div><VaporesSemanalesProveedorView operation={this.state.modalOperation} setModalBodyState={this.setModalBodyState}></VaporesSemanalesProveedorView></div>);
        //return (<div><VaporesSemanalesProveedorView ref={this.modalBodyState}></VaporesSemanalesProveedorView></div>);
    }
    async add_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.modalBodyState);
        const response = await fetch('api/vaporesSemanalesProveedor', {
            method: 'POST',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
        //const responceData = await response.json();
    }
    async edit_onclick(id) {
        const modalBody = await this.edit_modal_body(id);
        this.setState({
            modalHeader: this.edit_modal_header(id),
            modalBody: modalBody,
            modalState: true,
            modalOperation: 'edit',
        });
    }
    edit_modal_header(id) {
        return (<div><FormattedMessage id='Editar' /></div>);
    }
    async edit_modal_body(id) {
        const token = await authService.getAccessToken();
        const response = await fetch('api/vaporesSemanalesProveedor/' + id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const responceData = await response.json();
        return (<div><VaporesSemanalesProveedorView operation={this.state.modalOperation} setModalBodyState={this.setModalBodyState} data={responceData}></VaporesSemanalesProveedorView></div>);
        //return (<div><VaporesSemanalesProveedorView ref={this.modalBodyState}></VaporesSemanalesProveedorView></div>);
    }
    async edit_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.modalBodyState);
        const response = await fetch('api/vaporesSemanalesProveedor/' + this.modalBodyState.vaporSemanalProveedor_Id, {
            method: 'PUT',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
    }
    async delete_onclick(id) {
        const modalBody = await this.delete_modal_body(id);
        this.setState({
            modalHeader: this.delete_modal_header(id),
            modalBody: modalBody,
            modalState: true,
            modalOperation: 'delete',
            modalIsValid: true
        });
    }
    delete_modal_header(id) {
        return (<div><FormattedMessage id='Eliminar' /></div>);
    }
    async delete_modal_body(id) {
        const token = await authService.getAccessToken();
        const response = await fetch('api/vaporesSemanalesProveedor/' + id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const responceData = await response.json();
        await this.setModalBodyState({ model: responceData });
        return (<div><VaporesSemanalesProveedorDelete setModalBodyState={this.setModalBodyState} data={responceData}></VaporesSemanalesProveedorDelete></div>);
    }
    async delete_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/vaporesSemanalesProveedor/' + this.modalBodyState.vaporSemanalProveedor_Id, {
            method: 'DELETE',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
    }
    async clean_onclick() {
        this.setState({
            searchModel: { viaje: "" }
        });
        await this.populateData()
    }

    async setModalBodyState(state) {
        this.modalBodyState = state.model;
        if (state.modelValidation) {
            var modalIsValid = !Object.keys(state.modelValidation).some(function (val) {
                return state.modelValidation[val] == false;
            });
            this.setState({
                modalIsValid: modalIsValid
            });
        }

    }
    async load_semana() {
        var rawUrl = window.location.toString();
        var semana_Id = rawUrl.split("Semanas/")[1].split("/")[0];
        const token = await authService.getAccessToken();
        const response = await fetch('api/semanas/' + semana_Id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_navieras() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/navieras/', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_barcos() {
        if (this.state.searchModel.naviera_Id != 0) {
            const token = await authService.getAccessToken();
            const response = await fetch('api/VaporesSemanales?semana_Id=' + this.state.semana.semana_Id + '&naviera_Id=' + this.state.searchModel.naviera_Id, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
            });
            return await response.json();
        }
        else {
            return [];
        }
    }
}